/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality. 
 */

import { loading, reCAPTCHAv3 } from "commonAssets/js/constants"
import { createElement, loadingGif, modal, toggleFieldError, validateField } from "commonAssets/js/helpers"
import { e, ee } from "commonAssets/lib/selector"
import dealers from "../docs/dealers/db.json"

export const disclaimer = `The extended coverage presented in 'VIN Check' through this 
    portal is based on the in-service time and mileage submitted at the time of inquiry. 
    PCNA reserves the right to modify coverage should the in-service 
    time and mileage differ at time of repair.`

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log('[Initiate claim]...')

    const claimId = claim.class_member.claim_id

    const initFunctions = [
        serviceCenterInformationHandler(),
        removeUnusedHtmlElements(),
        showHiddenFieldsForClaimId(claimId),
        addClassSelectors(),
        localStorageClearBeforeUnload(),
        _inputsHandler(claim),
        _trxTableCtrl(),
        _additionalTrxTableLanguage(),
        _cpoWarrantyQuestion(claimId),
        //toggleFormVisibility(),
        hideDocumentationOnVinCheck(),
    ]

    initFunctions.forEach(func => {
        if (typeof func === 'function') {
            func()
        }
    })


    return claim
}

function hideDocumentationOnVinCheck() {
    if (window.location.pathname.includes('vin-check-form')) {
        e('#documentation').classList.add('d-none')
    }
}

function toggleFormVisibility() {
    let path = window.location.pathname.split('/')[1]
    const trxPathCtrl = {
        'vin-check-form': {
            parent: document.querySelector("#table_responsive_1"),
        },
        'submit-claim-form': {
            parent: document.querySelector("#table_responsive_2"),
        }
    }
    if (path === 'vin-check-form') {
        trxPathCtrl['submit-claim-form'].parent.classList.add('d-none')
        trxPathCtrl['submit-claim-form'].parent.querySelectorAll('input, select, textarea').forEach(e => {
            e.removeAttribute('data-validate')
            e.removeAttribute('required')
        })
        trxPathCtrl['submit-claim-form'].docs
    } else if (path === 'submit-claim-form') {
        trxPathCtrl['vin-check-form'].parent.classList.add('d-none')
        trxPathCtrl['vin-check-form'].parent.querySelectorAll('input, select, textarea').forEach(e => {
            e.removeAttribute('data-validate')
            e.removeAttribute('required')
        })
    }
}

function _cpoWarrantyQuestion(claimId) {
    // console.log(claimId)

    const trxTable = e('#transactions')

    const title = `<div class="h3 mb-3 formTitle"><i class="bi bi-calendar-check"></i> CPO Warranty</div>`
    const body = `<div class="formBody" id="cpoWarrantyQuestionBody"></div>`

    const div = createElement('div', {
        class: "bg-light text-dark border rounded p-3 mb-5",
        id: "cpoWarrantyQuestion"
    }, [], title + body)

    trxTable.insertAdjacentElement('afterend', div)

    const cpoWarrantyQuestionBody = e('#cpoWarrantyQuestionBody')

    ee('.cpo-warranty-div').forEach(e => {
        cpoWarrantyQuestionBody.appendChild(e)
    })

    ee('.cpo-warranty-start-parent, .cpo-warranty-end-parent, .cpo-warranty-note-parent').forEach(e => {
        e.classList.add('d-none')
    })

    document.querySelector('#select-cpo-warranty').addEventListener('change', e => {

        const selectedValue = e.target.value

        if (selectedValue === 'YES') {
            document.querySelectorAll('.cpo-warranty-start-parent, .cpo-warranty-end-parent, .cpo-warranty-note-parent').forEach(e => {
                e.classList.remove('d-none')
            })
        } else {
            document.querySelectorAll('.cpo-warranty-start-parent, .cpo-warranty-end-parent, .cpo-warranty-note-parent').forEach(e => {
                e.classList.add('d-none')
            })
            document.querySelector('.cpo-warranty-start-parent').querySelector('input').value = ''
            document.querySelector('.cpo-warranty-end-parent').querySelector('input').value = ''
        }
    })

    if (claimId && document.querySelector('#select-cpo-warranty').value === 'YES') {
        ee('.cpo-warranty-start-parent, .cpo-warranty-end-parent, .cpo-warranty-note-parent').forEach(e => {
            e.classList.remove('d-none')
        })
    }
}

function _additionalTrxTableLanguage() {

    const div = createElement('div', {
        class: "alert alert-info text-center mt-3",
    }, [], disclaimer)

    const prevCleanings = createElement("div", { class: "mt-5 d-none" }, [
        createElement("h3", { class: "mb-3" }, [], `Previous Annual Sunroof Drain Cleanings`),
        createElement("div", { id: "previous-cleanings" }, [], `No previous data`),
    ]);

    const prevRepairs = createElement("div", { class: "mt-5 d-none" }, [
        createElement("h3", { class: "mb-3" }, [], `Previous Covered Repairs`),
        createElement("div", { id: "previous-repairs" }, [], `No previous data`),
    ]);

    e('#transactions').appendChild(div)
    e('#transactions').appendChild(prevCleanings)
    e('#transactions').appendChild(prevRepairs)
}

function showHiddenFieldsForClaimId(claimId) {
    const path = window.location.pathname.split('/')[1]
    console.log(path)
    // if (!claimId) return
    if (path === 'vin-check-form') return
    ee('#claim-fields .d-none').forEach(e => {
        if (e.classList.contains('legacy-hidden')) return;
        e.classList.remove('d-none')
        if (e.querySelector('input')) e.querySelector('input').disabled = true
    })
}

function _trxTableCtrl() {

    // Remove the transaction table text body and caption
    e('#transactions > div.mb-3.formBody').remove()

    e('#transactions_1 > caption').remove()
    //e('#inq-date__1').value = todaysDate
    e('#add_transactions_1').parentElement.classList.add('d-none')

    // e('#transactions_2 > caption').remove()
    // e('#trx-date__1').value = todaysDate
    // e('#add_transactions_2').parentElement.classList.add('d-none')
}

function serviceCenterInformationHandler() {

    // Default values for first, last name
    e('#first_name').value = 'Service'
    e('#last_name').value = 'Warranty'

    // Define the fields to be disabled
    const disableFields = [
        e('#first_name'),
        e('#last_name'),
        e('#street_address_1'),
        e('#street_address_2'),
        e('#city'),
        e('#state'),
        e('#province'),
        e('#zip_code'),
        e('#postal_code'),
        e('#country'),
        e('#phone_number_1'),
        e('#phone_number_2'),
    ]

    // Disable the fields
    disableFields.forEach(field => {
        // field.setAttribute('disabled', 'true')
        field.parentElement.classList.add('d-none')
        field.required = false
        field.setAttribute('data-validate', '')
    })

    // Set the default values for the fields
    const dealerDataList = createElement('datalist', {
        id: "dealerList"
    })
    e('#business_name').setAttribute('list', 'dealerList')
    e('#business_name').setAttribute('autocomplete', 'off')
    e('#business_name').insertAdjacentElement('afterend', dealerDataList)
    dealers.forEach(dealer => {
        const option = createElement('option', {
            value: `${dealer.PIA_DLR_CODE} - ${dealer.NAME} (${dealer.ENTITY}), ${dealer.ADDRESS}, ${dealer.CITY}, ${dealer.STATE} ${dealer.ZIP}`
        })
        dealerDataList.appendChild(option)
    })

    // Once the business name is selected, set the address fields
    e('#business_name').addEventListener('input', e => {
        const selectedDealer = dealers.find(dealer => {
            return `${dealer.PIA_DLR_CODE} - ${dealer.NAME} (${dealer.ENTITY}), ${dealer.ADDRESS}, ${dealer.CITY}, ${dealer.STATE} ${dealer.ZIP}` === e.target.value
        })

        if (selectedDealer) {
            document.querySelector('#street_address_1').value = selectedDealer.ADDRESS
            document.querySelector('#city').value = selectedDealer.CITY
            document.querySelector('#state').value = selectedDealer.STATE
            document.querySelector('#zip_code').value = selectedDealer.ZIP
        }
    })

    e('#business_name').addEventListener('blur', () => {
        const value = e('#business_name').value;
        const options = Array.from(document.getElementById('dealerList').options).map(option => option.value);

        if (!options.includes(value)) {
            toggleFieldError(e('#business_name'), true, 'Please select a valid option.');
        } else {
            toggleFieldError(e('#business_name'), false);
        }
    });
}

function _inputsHandler(claim) {

    const claimId = claim.class_member.claim_id

    // Define the inputs to be disabled
    const inputs = [
        document.querySelector("[name=\"vin\"]"),
        document.querySelector("[name=\"year\"]"),
        document.querySelector("[name=\"model\"]"),
        document.querySelector("[name=\"in_service_date\"]")
    ]

    // Check if the claimId is present
    let classMember = claimId ? claim.class_member.class_member : claim.class_member

    // Format the in_service_date to YYYY-MM-DD
    classMember.in_service_date = classMember.in_service_date.split('T')[0]

    // Set the values of the inputs
    document.querySelector("[name=\"vin\"]").value = classMember.vin
    document.querySelector("[name=\"year\"]").value = classMember.year
    document.querySelector("[name=\"model\"]").value = classMember.model
    document.querySelector("[name=\"in_service_date\"]").value = classMember.in_service_date

    // Disable the inputs
    inputs.forEach(input => {
        input.setAttribute('disabled', 'true')
        input.classList.add('disabled')
    })

    return claim
}

function localStorageClearBeforeUnload() {
    // Clear local storage on unload
    window.addEventListener('beforeunload', function (event) {
        localStorage.clear()
    })
}

function addClassSelectors() {
    // Add a class to the contact field
    const elements = {
        divContactField_0: {
            selector: document.querySelector("#divContactField_0"),
            classList: {
                add: ['w-100']
            },
            active: true
        }
    }
    // Loop through the elements and add the class if they exist
    Object.keys(elements).forEach(key => {
        const element = elements[key]
        if (element.selector && element.active) {
            element.classList.add.forEach(className => {
                element.selector.classList.add(className)
            })
        }
    })
}

function removeUnusedHtmlElements() {
    // Remove the following elements if they exist
    const elements = {
        vinCheckerContainer: {
            selector: document.querySelector("#vinCheckerContainer"),
            remove: true
        },
        claimFormDeadline: {
            selector: document.querySelector("#claimFormDeadline"),
            remove: true
        },
        editClaim: {
            selector: document.querySelector("#editClaim"),
            remove: true
        }
    }
    // Loop through the elements and remove them if they exist
    Object.keys(elements).forEach(key => {
        const element = elements[key]
        if (element.selector && element.remove) {
            element.selector.remove()
        }
    })
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log('[Load class member]...')
    console.log(claim);
    if (claim.data.claim_id) {
        e('#add_transactions_1').click();
    }
    document.getElementById('business_name').value = '';
    document.getElementById('email_address').value = '';
    document.getElementById('confirm_email_address').value = '';
    document.getElementById('signature').value = '';
    // custom code goes here
    return claim
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log('[Process claim]...')

    /**
     * If CPO Warranty is YES, either the start date or end date must be filled
     * If CPO Warranty is NO, both the start date and end date must be empty
     */
    const cpoQuestion = document.querySelector("#select-cpo-warranty").value
    const cpoStartDate = document.querySelector("#date-cpo-warranty-start").value
    const cpoEndDate = document.querySelector("#date-cpo-warranty-end").value

    if (cpoQuestion === 'YES') {
        if (cpoStartDate === '' || cpoEndDate === '') {
            modal('Error', 'Please fill in the <strong>CPO Warranty Start Date</strong> and <strong>CPO Warranty End Date</strong>.')
            claim.flags.valid = false
            return claim
        }
    }

    if (cpoQuestion === 'NO') {
        if (cpoStartDate !== '' || cpoEndDate !== '') {
            modal('Error', 'Please remove the <strong>CPO Warranty Start Date</strong> and <strong>CPO Warranty End Date</strong>.')
            claim.flags.valid = false
            return claim
        }
    }

    if (e('#business_name').value) {
        const value = e('#business_name').value;
        const options = Array.from(document.getElementById('dealerList').options).map(option => option.value);

        if (!options.includes(value)) {
            claim.flags.valid = false;
            toggleFieldError(e('#business_name'), true, 'Please select a valid option.');
        }
    };

    /**
     * Supporting Documentation Handling
     */
    let docsRequired = false
    let docsFound = false

    // if path is submit-claim-form, docsRequired = true
    if (window.location.pathname.includes('submit-claim-form')) {
        docsRequired = true
    }

    if (claim.uploads.length > 0) {
        docsFound = true
    }

    if (docsRequired && !docsFound) {
        modal('Error', 'Please upload the required <strong>Final Repair Order or Invoice</strong>.')
        claim.flags.valid = false
        return claim
    }

    return claim
}
